import * as React from 'react';
import { useShouldRenderBlueprint } from '../../useShouldRenderBlueprint';
import VariantComponent from '../../variant-component';
import BuieDateField from './buie-date-field';
import BlueprintDateField from './blueprint-date-field';

type VariantDateFieldProps = {
  className?: string;
  description?: React.ReactNode;
  error?: React.ReactNode | string;
  infoText?: React.ReactNode | string;
  isDisabled?: boolean;
  isInTwoColumn?: boolean;
  isRequired?: boolean;
  label: React.ReactNode;
  onChange: (...args: unknown[]) => unknown;
  value: string;
  isSubmitter?: boolean;
};

export const VariantDateField = React.memo<VariantDateFieldProps>(
  (props: VariantDateFieldProps) => {
    // Should be addressed in FORMS-21205
    const shouldRenderBlueprint = useShouldRenderBlueprint();
    return (
      <VariantComponent
        {...props}
        NewComponent={BlueprintDateField}
        OldComponent={BuieDateField}
        shouldRenderNewComponent={shouldRenderBlueprint}
      />
    );
  },
);

export default VariantDateField;
